import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import ProtectedRoute from "@/components/ProtectedRoute";
import Header from "@/components/Header";
import LoginPage from "@/pages/LoginPage";
import RecipesList from "@/pages/RecipesList";
import RecipeBuilder from "@/pages/RecipeBuilder";
import LibraryPage from "@/pages/LibraryPage";

// Auto-logout on 401 (token expired)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname !== "/login") {
      localStorage.removeItem("nutrical_token");
      delete api.defaults.headers.common.Authorization;
      window.location.assign("/login");
    }
    return Promise.reject(err);
  }
);

const AuthenticatedShell = () => (
  <>
    <Header />
    <Routes>
      <Route path="/" element={<RecipesList />} />
      <Route path="/recettes/nouvelle" element={<RecipeBuilder />} />
      <Route path="/recettes/:id" element={<RecipeBuilder />} />
      <Route path="/bibliotheque" element={<LibraryPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </>
);

function App() {
  return (
    <div className="App min-h-screen bg-stone-50">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <AuthenticatedShell />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster
            position="bottom-right"
            richColors
            toastOptions={{
              classNames: { toast: "border border-stone-200 shadow-lg" },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
